var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-overlay-border",class:[
    {
      f: _vm.isFirst,
      l: _vm.isLast,
    },
    _vm.$props.borderMode ],style:({
    borderLeftWidth: _vm.horizontalBorderWidth,
    borderRightWidth: _vm.horizontalBorderWidth,
  })})}
var staticRenderFns = []

export { render, staticRenderFns }